import { Component, OnInit, Input } from '@angular/core';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import {CssService} from "../../../services/css-service";
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";

@Component({
  selector: 'app-order-info-thumbnail',
  templateUrl: './order-info-thumbnail.component.html',
  styleUrls: ['./order-info-thumbnail.component.css']
})
export class OrderInfoThumbnailComponent implements OnInit {

  saleMethod: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

  constructor(
    private tools: ToolsService,
    public cssService: CssService,
    public dialogService: DialogsService
  ) { }

  ngOnInit() {

   }

}
